<template>
  <div class="partner-section" v-if="partners">
    <p class="title">Partneri projekta</p>

    <div>
      <a  :href="partner.imageLink"
          class="slide"
          :style="(partner && partner.imageUrl)?'background-image: url(' + partner.imageUrl + ')' : ''"
          v-for="(partner, index) in partners" v-bind:key="index"></a>
    </div>
  </div>
</template>

<script>
export default {
    name: 'partneri',
    computed: {
        partners () {
            try {
                return this.$store.state.metadata.partners
            } catch (error) { console.error(error) }
            return []
        }
    }
}
</script>

<style lang="scss" scoped>
.partner-section {
  position: relative;
  text-align: left;
  margin-top: 20px;
  .title {
    font-family: "mPlus";
    font-size: 18px;
    letter-spacing: -.2px;
    color: #fff;
    padding-left: 24px;
    margin-bottom: 12px;
  }
  > div {
    overflow: hidden;
    overflow-x: auto;
    padding-bottom: 16px;
    white-space: nowrap;
    padding-left: 24px;
  }
  .slide {
    position: relative;
    display: inline-block;
    width: 96px;
    background-color: #fff;
    border-radius: 10px;
    min-height: 56px;
    background-repeat: no-repeat;
    background-position: 50% 50%;
    background-size: 75%;
    margin-right: 9px;
  }
  .slide:last-child {
    margin-right: 24px;
  }
}
</style>
